import { fetchPaymentMethods } from '@http/endpoints'

export default {
  namespaced: true,

  state: () => ({
    methods: [],
  }),

  mutations: {
    setMethods(state, methods) {
      state.methods = methods
    },
  },

  getters: {
    /**
     * @param {State} state
     * @param {Object} getters
     * @param {rootState} state
     * @param {Object} rootGetters
     * @returns {import('@payment').PaymentMethod[]}
     */
    methods: (state) => {
      return state.methods
    },
  },

  actions: {
    async fetchMethods({ commit, dispatch, rootGetters }) {
      const response = await dispatch(
        'http/request',
        {
          request: fetchPaymentMethods,
          queryParams: {
            country_code: rootGetters['config/country'],
            hide_unavailable: 1,
            bag_price: 300,
          },
        },
        { root: true },
      )

      commit('setMethods', response.payload?.results)
    },
  },
}
